<template>
    <div class="match-highlights-container">
        <div class="title">Sorotan & Putar Ulang</div>

        <div class="highlights-carousel">
            <iframe
              v-if="data.highlight_url"
              class="carousel-item"
              :src="data.highlight_url"
              frameborder="0"
              fs="0"
              modestbranding="1"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;fs;modestbranding"
              allowfullscreen
            >
            </iframe>

            <div v-if="data.playback_url"  class="playback-carousel-item carousel-item" @click="handlePlayVideo(data.playback_url)"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => ({
                highlight_url:'',
                playback_url:''
            })
        }
    },

    methods: {
        handlePlayVideo(url) {
            window.open(url, '_blank');
        }
    }
}
</script>

<style lang="less" scoped>
* {
    box-sizing: border-box;
}

.match-highlights-container {
    .title {
        display: block;
        height: 1.875rem;
        margin: 0;
        padding: 0 0 0 0.9375rem;
        line-height: 1.875rem;
        font-size: 0.9375rem;
        font-weight: 400;
        background-color: #e2e4e6;
    }

    .highlights-carousel {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 0.8125rem 0.6875rem;
        background: #FFFFFF;

        .carousel-item {
            width: 100%;
            height: 200px;
            cursor: pointer;

            &:nth-child(2){
                margin-top: .375rem;
            }
        }

        .playback-carousel-item.carousel-item{
            background: url('https://img.724bifen.com/fastdfs0/M00/00/10/rBVwNGZ-IU6ANMzXAAGEDZW2jwk412.jpg') no-repeat;
            background-size: cover;
        }
    }
}

@media screen and (min-width: 700px) {
    .match-highlights-container {
        .highlights-carousel {
            flex-direction: row;

            .carousel-item {

                &:nth-child(2) {
                    margin-top: 0;
                    margin-left: .375rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// AppMatchHighlights.vue?26ec9f42